/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface SMSLinkMethodOptions
 */
export interface SMSLinkMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof SMSLinkMethodOptions
     */
    method: FactorMethod;
    /**
     * URI to redirect to after resolving the challenge.
     * @type {string}
     * @memberof SMSLinkMethodOptions
     */
    redirect_target?: string;
}

/**
 * Check if a given object implements the SMSLinkMethodOptions interface.
 */
export function instanceOfSMSLinkMethodOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function SMSLinkMethodOptionsFromJSON(json: any): SMSLinkMethodOptions {
    return SMSLinkMethodOptionsFromJSONTyped(json, false);
}

export function SMSLinkMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMSLinkMethodOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'redirect_target': !exists(json, 'redirect_target') ? undefined : json['redirect_target'],
    };
}

export function SMSLinkMethodOptionsToJSON(value?: SMSLinkMethodOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
        'redirect_target': value.redirect_target,
    };
}

